const dev = {
  API_URL: "https://msapi.a10s.in/api",
};

const prod = {
  API_URL: "https://msapi.a10s.in/api",
};
const config = process.env.NODE_ENV == "development" ? dev : prod;
export default config;
